var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_606",
    "data-name": "Groupe 606",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.356,
    height: 43.046,
    viewBox: "0 0 30.356 43.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_534",
    "data-name": "Trac\\xE9 534",
    d: "M0-17.019H30.356V-60.065H0Z",
    transform: "translate(0 60.065)",
    fill: "#e30613"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_605",
    "data-name": "Groupe 605",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_604",
    "data-name": "Groupe 604",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_533",
    "data-name": "Trac\\xE9 533",
    d: "M-6.758-8.024C1.016-9.4,5.362-12.94,5.362-18.142c0-6.4-5.888-10.176-15.035-10.176a36.611,36.611,0,0,0-13.892,2.859v10.29h.515l8.518-11.719a12.13,12.13,0,0,1,2.915-.4c4.573,0,7.146,3.545,7.146,9.033,0,7.832-4.63,9.833-9.318,9.833h-2.859v1.086h3.487c4.63,0,9.775,2.23,9.775,10.976,0,6.288-3.144,10.061-8.289,10.061a9.681,9.681,0,0,1-2.973-.457l-8.69-11.891h-.515V11.87A38.62,38.62,0,0,0-9.559,14.729C.388,14.729,6.5,10.5,6.5,3.581,6.5-2.65,1.76-6.652-6.758-8.024",
    transform: "translate(23.851 28.318)",
    fill: "#e30613"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.73f1d5c502acd77d25007a7bcba3cc14.svg";
export { ForwardRef as ReactComponent };